import { SignUpQR } from 'containers/index';
import { FC } from 'react';

const SignUpPage: FC = () => {
  return <SignUpQR />;
};

export default SignUpPage;
